import React, { Component } from "react";
import { normalize } from "../lib/prob";
import { precisionRound } from "../lib/utils";

class Item {
    constructor(params) {
        this.params = params;
    }

    getProbFunc() {
        return (this.getComponentClass()).getProbFunc(this.params);
    }

    getComponentClass() {
    // what type of react component to render for this item?
        const nameToClassMap = {
            "BetweenXandYItem": BetweenXandYItem,
            "UpToXItem": UpToXItem,
            "EitherXorYItem": EitherXorYItem,
        };
        return nameToClassMap[this.params.type];
    }

}

class ItemBaseComponent extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onRemove = this.onRemove.bind(this);
    }

    handleChange(event) {
    // see https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        // if using checkboxes: const value = target.type === 'checkbox' ? target.checked : target.value;
        const value = target.value === '' ? '0': target.value;
        const name = target.name;
        this.props.onChangeData(this.props.index, name, value);
    }

    onRemove(event) {
        this.props.onRemove(this.props.index);
    }

    wrap(what) {
        return (
            <div className="item mb-2">
                <div className="form-row">
                    <div className="col-1 text-center">
                        <a className={"btn btn-sm btn-light remove " + (this.props.removable ? "" : "disabled")} onClick={ this.onRemove }>×</a>
                    </div>
                    <div className="col-11">
                        <input 
                            name="description"
                            type="text"
                            className="form-control"
                            placeholder="Doing something"
                            value={ this.props.description }
                            onChange={ this.handleChange }
                        />
                    </div>
                </div>
                <div className="item-details">
                    { what }
                </div>
            </div>
        );
    }
}

class UpToXItem extends ItemBaseComponent {
    render() {
        return this.wrap(<div className="form-row">
            <div className="col-11 offset-1">
                {" will "}
                {" "}{ this.props.verb }{" "}
                {" up to "}
      
                <input
                    name="max"
                    type="number"
                    placeholder="max"
                    required="required"
                    min="0"
                    className="form-control nowrap"
                    value={ this.props.max }
                    onChange={ this.handleChange }
                />
                {" "}{ this.props.unit }{" "}
            </div>
        </div>);
    }

    static getProbFunc(item) {
        let max = parseInt(item.max, 10);
        let pf = max > 0 ? new Array(max + 1).fill(1) : [1];
        return normalize(pf);
    }
}

class EitherXorYItem extends ItemBaseComponent {
    render() {
        return this.wrap(<div className="form-row">
            <div className="col-11 offset-1">
                {" will "}
                {" "}{ this.props.verb }{" "}
                {" either "}
                <input
                    name="either"
                    type="number"
                    required="required"
                    min="0"
                    placeholder=""
                    className="form-control"
                    value={ this.props.either }
                    onChange={ this.handleChange }
                />
                { " " }
                { this.props.unit }
                <span className="probability">
                    {" (p = "}
                    { precisionRound(1 - this.props.probOr, 2) }
                    { ")" }
                </span>
                {" or "}
                <input
                    name="or"
                    type="number"
                    required="required"
                    min="0"
                    placeholder=""
                    className="form-control"
                    value={ this.props.or }
                    onChange={ this.handleChange }
                />
                {" "}
                { this.props.unit }
                <span className="probability">
                    {" (p = "}
                    <input
                        name="probOr"
                        type="number"
                        required="required"
                        min="0.01"
                        max="0.99"
                        step="0.01"
                        placeholder=""
                        className="form-control"
                        value={ this.props.probOr }
                        onChange={ this.handleChange }
                    />{ ")" }
                </span>
            </div>
        </div>);
    }

    static getProbFunc(item) {
        let either = parseInt(item.either, 10);
        let or = parseInt(item.or, 10);
        let max = Math.max(either, or);
        let probOr = parseFloat(item.probOr);

        let pf = max > 0 ? new Array(max).fill(0) : [0];
        pf[either] = (1 - probOr);
        pf[or] = probOr;
        return normalize(pf);
    }
}

class BetweenXandYItem extends ItemBaseComponent {
    render() {
        return this.wrap(<div className="form-row">
            <div className="col-11 offset-1">
                {" will "}
                {" "}{ this.props.verb }{" "}
                {" between "}
                <input
                    name="min"
                    type="number"
                    required="required"
                    min="0"
                    placeholder="min"
                    className="form-control"
                    value={ this.props.min }
                    onChange={ this.handleChange }
                />
                {" and "}
                <input
                    name="max"
                    type="number"
                    required="required"
                    min="0"
                    placeholder="max"
                    className="form-control"
                    value={ this.props.max }
                    onChange={ this.handleChange }
                />
                {" "}{ this.props.unit }{" "}
            </div>
        </div>);
    }

    static getProbFunc(item) {
        let min = Math.max(parseInt(item.min, 10), 0);
        let max = Math.max(parseInt(item.max, 10), min);

        let zeros = min > 0 ? new Array(min).fill(0) : [];
        let ones  = new Array(1+max-min).fill(1);
        let pf = zeros.concat(ones);
        return normalize(pf);
    }
}

export { Item };
export { ItemBaseComponent };
export { BetweenXandYItem };
export { UpToXItem };
export { EitherXorYItem };


// WEBPACK FOOTER //
// ./src/components/Items.js